import css from 'styled-jsx/css';
import { colors, fonts } from 'components/styles/variables';
import closeIcon from 'public/static/images/paid_landing/close.svg';
import searchIcon from 'public/static/images/paid_landing/search-icon.svg';

export const styles = css`
  .search-container {
    display: flex;
    flex-direction: column-reverse;
    flex-grow: 1;
    position: relative;
  }

  .header-container {
    display: flex;
    height: 64px;
    align-items: center;
    padding: 21px 25px 21px 16px;
    width: 100%;
  }

  .spacer {
    height: 1px;
    background-color: ${colors.G2};
  }

  .search-icon {
    height: 26px;
    width: 26px;
    background: url(${searchIcon});
    background-size: cover;
  }

  .close-button {
    height: 26px;
    width: 26px;
    background: url(${closeIcon});
    background-size: cover;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }

  .dropdown-container {
    top: 50px;
    position: absolute;
    width: 100%;
  }
`;

export const inputStyles = css`
  .input-wrapper {
    display: flex;
    flex-grow: 1;
    align-items: center;
    border-radius: 4px;
    background-color: white;
  }

  .input-adornment {
    display: flex;
    align-items: center;
  }

  .text-search-input {
    flex-grow: 1;
    border: none;
    outline: none;
    padding: 8px;
    font-family: ${fonts.default};
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.2px;
    width: 100%;
  }

  .text-search-input:disabled {
    background: transparent;
  }

  .text-search-input::placeholder {
    color: ${colors.G3};
    font-weight: 300;
  }
`;
